module.exports = __webpack_public_path__ + "img/icono-instagram.e965538c.svg";